<header class="header" *ngIf="authState$ | async as authState" #header>
	<div class="header__wrapper">
		<div class="header__content__wrapper">
			<div class="logo" [routerLink]="['/']">
				<img
					*ngIf="
						appearance.useTheme && appearance.logo && isNotPortalManager;
						else defaultLogo
					"
					[src]="appearance.logo"
					alt="{{ currentStore?.name }} Logo"
				/>
				<ng-template #defaultLogo>
					<img
						class="logo-adv"
						src="assets/images/adv-portal-logo.png"
						alt="ADV Tecnologia Logo"
					/>
				</ng-template>
			</div>

			<div class="search__container" #searchWrapper>
				<app-search-box
					#searchBox
					*appIsNotPortalManager
					class="header__search"
					placeholder="Pesquisar um produto..."
					(blurSearchEvent)="autocompleteOverlayRef.hide()"
					(clickSearchEvent)="searchProduct($event, true)"
					(focusSearchEvent)="
						searchInputRef = searchBox;
						autocompleteOverlayRef = autocompleteOverlayPanel;
						autocompleteOverlayRef.show($event)
					"
					(searchEvent)="search = $event"
				></app-search-box>

				<p-overlayPanel
					#autocompleteOverlayPanel
					styleClass="autocomplete__panel"
					[appendTo]="searchWrapper"
					[dismissable]="false"
					[style]="{ width: searchBoxClientRect.width + 'px' }"
				>
					<ng-template pTemplate>
						<app-autocomplete-overlay-panel
							[search]="search"
						></app-autocomplete-overlay-panel>
					</ng-template>
				</p-overlayPanel>
			</div>

			<div class="header__actions">
				<ng-container *ngIf="authState?.isAuthenticated; else showLogin">
					<!-- Seller Order CTA (seller/admin only) -->
					<ng-container *ngIf="isSellerOrAdmin">
						<!-- Desktop: label + icon -->
						<div class="seller-order-cta seller-order-cta--desktop">
							<p-button
								label="Novo pedido"
								icon="pi pi-plus"
								styleClass="p-button-sm"
								(onClick)="sellerOrderMenu.toggle($event)"
							>
								<i
									*ngIf="draftCount > 0"
									pBadge
									severity="warning"
									class="seller-order-badge"
									[value]="draftCount.toString()"
								></i>
							</p-button>
						</div>

						<!-- Tablet: icon only -->
						<div class="seller-order-cta seller-order-cta--tablet">
							<p-button
								icon="pi pi-plus"
								styleClass="p-button-sm"
								pTooltip="Novo pedido"
								tooltipPosition="bottom"
								[showDelay]="1000"
								(onClick)="sellerOrderMenu.toggle($event)"
							>
								<i
									*ngIf="draftCount > 0"
									pBadge
									severity="warning"
									class="seller-order-badge"
									[value]="draftCount.toString()"
								></i>
							</p-button>
						</div>

						<p-menu
							#sellerOrderMenu
							styleClass="panel__group"
							[popup]="true"
							[model]="sellerOrderMenuItems"
							[appendTo]="header"
						></p-menu>

						<!-- Mobile: FAB (hidden on the order screen, which has its own bottom bar) -->
						<div
							*ngIf="!isOnSellerOrderPage"
							class="seller-order-cta seller-order-cta--mobile"
						>
							<p-button
								label="Novo pedido"
								icon="pi pi-plus"
								styleClass="p-button-rounded seller-order-fab"
								(onClick)="navigateToNewOrder()"
							>
								<i
									*ngIf="draftCount > 0"
									pBadge
									severity="warning"
									class="seller-order-badge"
									[value]="draftCount.toString()"
								></i>
							</p-button>
						</div>
					</ng-container>

					<p-button
						*appIsCustomer
						icon="fa-solid fa-heart"
						styleClass="p-button-text p-button-sm"
						pTooltip="Favoritos"
						tooltipPosition="bottom"
						[showDelay]="1000"
						[disabled]="isLoggingOut"
						(onClick)="favDialog()"
					></p-button>

					<p-button
						*appIsCustomer
						styleClass="fa-solid fa-cart-shopping p-button-text p-button-sm cart"
						pTooltip="Carrinho"
						tooltipPosition="bottom"
						[showDelay]="1000"
						[disabled]="isLoggingOut"
						(onClick)="hasPackingFeature ? openCart() : cartDialog()"
					>
						<i
							*ngIf="cartTotalItems > 0"
							pBadge
							[value]="cartTotalItems.toFixed(stockDecimalPlaces)"
						></i>
					</p-button>

					<ng-container *ngIf="showMessagesTab">
						<ng-container *ngIf="unreadOrderMessages$ | async as unread">
							<p-button
								*appIsNotPortalManager
								styleClass="fa-solid fa-message p-button-text p-button-sm cart"
								pTooltip="Mensagens não lidas"
								tooltipPosition="bottom"
								[showDelay]="1000"
								[disabled]="isLoggingOut"
								(onClick)="msgsOverlayPanel.toggle($event)"
							>
								<i
									*ngIf="unread.total > 0"
									pBadge
									[value]="unread.total.toString()"
								></i>
							</p-button>

							<p-overlayPanel
								#msgsOverlayPanel
								styleClass="panel__group overlay__msgs"
								[appendTo]="header"
							>
								<ng-template pTemplate>
									<app-unread-order-msgs-panel
										[list]="unread.list"
										(clickOpenCartEvent)="msgsOverlayPanel.hide()"
										(emptyCartEvent)="msgsOverlayPanel.hide()"
									></app-unread-order-msgs-panel>
								</ng-template>
							</p-overlayPanel>
						</ng-container>
					</ng-container>

					<p-button
						(mouseenter)="planTooltip.hide()"
						#accountButton
						styleClass="p-button-text p-button-sm account__button"
						pTooltip="Conta"
						tooltipPosition="bottom"
						[showDelay]="1000"
						[loading]="isLoggingOut"
						(mouseenter)="planTooltip.hide()"
						(onClick)="accountMenu.toggle($event)"
					>
						<ng-template pTemplate="content">
							<p-avatar
								styleClass="user__image"
								[image]="authState.user?.profileImageUrl || ''"
								[label]="
									!authState.user?.profileImageUrl
										? getNameLabel(authState.user?.name)
										: ''
								"
								shape="circle"
							></p-avatar>
						</ng-template>
					</p-button>
					<p-menu
						styleClass="panel__group"
						#accountMenu
						[popup]="true"
						[model]="accountOptions"
						[appendTo]="header"
						(mouseleave)="planTooltip.hide()"
						(onShow)="checkHasFeatures()"
					></p-menu>
					<p-overlayPanel styleClass="custom__tooltip" #planTooltip>
						<ng-template pTemplate>
							<app-plan-tooltip
								(mouseleave)="planTooltip.hide()"
							></app-plan-tooltip>
						</ng-template>
					</p-overlayPanel>
				</ng-container>

				<ng-template #showLogin>
					<p-button
						styleClass="p-button-text p-button-sm"
						icon="pi pi-user-plus"
						label="Cadastrar"
						tooltipPosition="bottom"
						[routerLink]="['/new-customer']"
					></p-button>
					<p-button
						styleClass="p-button-text p-button-sm"
						icon="fa-solid fa-right-to-bracket"
						pTooltip="Fazer login"
						label="Entrar"
						tooltipPosition="bottom"
						(onClick)="login()"
					></p-button>
				</ng-template>
			</div>
		</div>

		<ng-container *appIsNotPortalManager>
			<div
				*ngIf="items?.length"
				class="header__content__menubar"
				[class.menubar__sm]="items.length <= 5"
			>
				<p-menubar appendTo="body" [autoDisplay]="true" [model]="items">
				</p-menubar>
			</div>
		</ng-container>
	</div>
</header>
